const InstagramLogo = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="28" height="28" rx="8" fill="white"/>
    <path d="M18.8503 2H9.14973C5.20735 2 2 5.20735 2 9.14973V18.8503C2 22.7926 5.20735 26 9.14973 26H18.8503C22.7926 26 26 22.7926 26 18.8503V9.14973C26 5.20735 22.7926 2 18.8503 2ZM23.5856 18.8503C23.5856 21.4655 21.4655 23.5856 18.8503 23.5856H9.14973C6.5345 23.5856 4.4144 21.4655 4.4144 18.8503V9.14973C4.4144 6.53446 6.5345 4.4144 9.14973 4.4144H18.8503C21.4655 4.4144 23.5856 6.53446 23.5856 9.14973V18.8503Z" fill="url(#paint0_linear_1736_2250)"/>
    <path d="M14.0002 7.79297C10.5775 7.79297 7.79297 10.5775 7.79297 14.0002C7.79297 17.4228 10.5775 20.2074 14.0002 20.2074C17.4229 20.2074 20.2075 17.4229 20.2075 14.0002C20.2075 10.5775 17.4229 7.79297 14.0002 7.79297ZM14.0002 17.7931C11.9055 17.7931 10.2074 16.095 10.2074 14.0002C10.2074 11.9055 11.9055 10.2074 14.0002 10.2074C16.095 10.2074 17.7931 11.9055 17.7931 14.0002C17.7931 16.0949 16.0949 17.7931 14.0002 17.7931Z" fill="url(#paint1_linear_1736_2250)"/>
    <path d="M20.2179 9.32658C21.0393 9.32658 21.7052 8.66065 21.7052 7.83919C21.7052 7.01773 21.0393 6.35181 20.2179 6.35181C19.3964 6.35181 18.7305 7.01773 18.7305 7.83919C18.7305 8.66065 19.3964 9.32658 20.2179 9.32658Z" fill="url(#paint2_linear_1736_2250)"/>
    <defs>
      <linearGradient id="paint0_linear_1736_2250" x1="14" y1="25.9301" x2="14" y2="2.18641" gradientUnits="userSpaceOnUse">
        <stop stopColor="#E09B3D"/>
        <stop offset="0.3" stopColor="#C74C4D"/>
        <stop offset="0.6" stopColor="#C21975"/>
        <stop offset="1" stopColor="#7024C4"/>
      </linearGradient>
      <linearGradient id="paint1_linear_1736_2250" x1="14.0002" y1="25.9304" x2="14.0002" y2="2.18664" gradientUnits="userSpaceOnUse">
        <stop stopColor="#E09B3D"/>
        <stop offset="0.3" stopColor="#C74C4D"/>
        <stop offset="0.6" stopColor="#C21975"/>
        <stop offset="1" stopColor="#7024C4"/>
      </linearGradient>
      <linearGradient id="paint2_linear_1736_2250" x1="20.2179" y1="25.93+" x2="20.2179" y2="2.18626" gradientUnits="userSpaceOnUse">
        <stop stopColor="#E09B3D"/>
        <stop offset="0.3" stopColor="#C74C4D"/>
        <stop offset="0.6" stopColor="#C21975"/>
        <stop offset="1" stopColor="#7024C4"/>
      </linearGradient>
    </defs>
  </svg>
);

export default InstagramLogo;
